import { MatchKeyLanding } from "@/components/MatchKey/MatchKeyShell";
import { KARNOFFEL_CFG } from "@/components/MatchKey/cfgs";

export default function KarnoffelLanding() {
  return <MatchKeyLanding cfg={KARNOFFEL_CFG} />;
}
